import { render, staticRenderFns } from "./AdditionalFieldsForm.vue?vue&type=template&id=3c25dc40&scoped=true"
import script from "./AdditionalFieldsForm.vue?vue&type=script&lang=js"
export * from "./AdditionalFieldsForm.vue?vue&type=script&lang=js"
import style0 from "./AdditionalFieldsForm.vue?vue&type=style&index=0&id=3c25dc40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c25dc40",
  null
  
)

export default component.exports